import React, {  useEffect} from 'react';
//import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
 
import { Link, useNavigate } from "react-router-dom";
import AxiosFetchData from '../pages/AxiosFetchData';

export default function CustomizedSnackbars() {
  const [open, setOpen] = React.useState(false);
  const [project, setProject] = React.useState(0);
  const [role, setRole] = React.useState('');
  const [user, setUser] = React.useState('');
  const Navigate = useNavigate();
//   const handleClick = () => {
//     setOpen(true);
//   };
const refreshToken = async () => {
    try {
        var notif;
        const token = await AxiosFetchData.token().refreshToken(Navigate);
        if(token){
           // console.log(token);
           setRole(token.role);
           setUser(token.name);
            
            if(token.role == "SE"){
                notif = await AxiosFetchData.get(`GetProjectNotification/${token.userID}`).refreshToken(Navigate);
                // setText(`There are <b>${notif.data.length}</b> new project has been assigned to you  <br/>
                //             Ignore this if you have already work on these project`)
            }
            
            if(token.role == "PM"){
                notif = await AxiosFetchData.get(`GetPONotification/${token.userID}`).refreshToken(Navigate);
                // setText(`There are <b>${notif.data.length}</b> new PO hasnt been assigned<br/>
                //     Ignore this if you have already assign on these project`)
            }

            if(notif.data.length > 0){
                //if(notif.data[0].counts > 0){
                   // document.getElementById('notif').innerHTML = "Aaa";
                    setOpen(true);
                    setProject(notif.data.length);
               // }
            }
        }
         
       
    } catch (error) {
        //Navigate('/');
      //  console.error('Error  :', error);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
 
  useEffect(() => {
    refreshToken()
  
  }, []);

  return (
    <div>
      {/* <Button onClick={handleClick}>Open Snackbar</Button> */}
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        {role == "SE" ? (
        <Alert
          onClose={handleClose}
          severity="error"
          variant="filled"
          sx={{ width: '100%'}}
          id='notif'
        >
         Hi,{user}.<br></br> There are  <Link to="/ListPOEng"><b>{project} new project</b></Link> has been assigned to you <br/>
         Ignore this if you have already work on these project  
         
        </Alert>
        ):(
            <Alert
          onClose={handleClose}
          severity="error"
          variant="filled"
          sx={{ width: '100%'}}
          id='notif'
        >
        Hi,{user}.<br></br> There are <Link to="/ListPO"><b>{project}  new PO</b></Link>  hasn't been assigned<br/>
        Ignore this if you have already assign on these project 
         
        </Alert>
        )}
      </Snackbar>
    </div>
  );
}